module.exports = __webpack_public_path__ + "static/img/team-worker-icon.836423eb.png";